import { faSave } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getNotificationItemInfo } from "../helpers/Converters";

//notifications types include "created", "removed", "saved"

export const useNotificationNavigation = (
  notificationType,
  notifications,
  url,
  name
) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (
      notifications?.length === 1 &&
      notifications?.[0].result === notificationType &&
      notifications?.[0]?.name === (name ?? notifications?.[0]?.name)
    ) {
      const nav = url?.replace?.("[id]", notifications?.[0]?.resultPayload?.id);
      navigate(nav ?? url, { replace: true });
    }
  }, [notifications, navigate, url, name, notificationType]);
};

export const useNotificationAction = (
  notificationType,
  notifications,
  action,
  name
) => {
  useEffect(() => {
    if (
      notifications?.length === 1 &&
      notifications?.[0].result === notificationType &&
      notifications?.[0]?.name === (name ?? notifications?.[0]?.name)
    ) {
      action(notifications?.[0]);
    }
  }, [notifications, action, name, notificationType]);
};

export const useNotificationBanner = (settings) => {
  const [unsaved, setUnsaved] = useState(false)
  let banner = false

  if(settings === undefined)
  {
    return [banner, setUnsaved]
  }
  //currently available settings
  const {notifications, bannerActions, timeoutAction, defaultBanner, navigationActions} = settings
  const hasNotifications = notifications?.length > 0;

  if(defaultBanner)
  {
    banner = defaultBanner
  }

  if (unsaved) {
    banner = {
      title: getNotificationItemInfo(`There are unsaved changes!`, faSave),
      state: "grey",
      bannerActions: bannerActions?.filter?.(ba => ba.result === "unsaved"),
      type: "unsaved"
    };
  }

  const getActions = (notification, bannerActions) => {
    let actions = [];
    if(notification?.bannerActions){
      actions.push(...notification.bannerActions)
    }
    if(bannerActions)
    {
      actions.push(...bannerActions?.filter?.(ba => (ba.result ?? notification.result) === notification.result))
    }
    return actions
  }

  if (hasNotifications) {
    banner = {
      notifications: notifications.map((n) => ({
        ...n,
        pageActions: getActions(n, bannerActions),
      })),
      navigationActions,
      timeoutAction: timeoutAction,
      timeout: notifications?.[0].timeout,
    };
  }
  
  return [banner, setUnsaved]
};


export const getSaveBannerActions = (save, goBack) => {
  return [
    {
      id: 0,
      result: "saved",
      title: "back",
      type: "secondary black",
      actionClick: goBack,
    },
    {
      id: 1,
      result: "created",
      title: "back",
      type: "secondary black",
      actionClick: goBack,
    },
    {
      id: 2,
      result: "unsaved",
      title: "save",
      type: "secondary black",
      actionClick: save,
    },
    {
      id: 3,
      result: "unsaved",
      title: "discard",
      type: "secondary white",
      actionClick: goBack,
    },
    {
      id: 3,
      result: "invite",
      title: "accept",
      type: "secondary white",
      actionClick: goBack,
    },
  ];
};